import { useAssertedParams } from '@folio/lib';
import { useExpectedUploadedDocuments } from '@folio/utils/useExpectedUploadedDocuments';
import { useQuery } from '@tanstack/react-query';
import { configControllerGetPublicTenantConfigQueryOptions } from 'korint-sdk';
import { useTranslation } from 'react-i18next';
import { DocumentsListBrokerageFirmModule } from '../DocumentsListBrokerageFirmModule/DocumentsListBrokerageFirmModule';
import { DocumentsUploadBrokerageFirmModule } from '../DocumentsUploadBrokerageFirmModule/DocumentsUploadBrokerageFirmModule';

type IntermediaryDetailsDocumentsModuleProps = {
  /**
   * Categories offered for upload on top of the ones the firm is expected to provide.
   */
  extraDocuments?: ReadonlyArray<{ category: string }>;
};

export function IntermediaryDetailsDocumentsModule({
  extraDocuments = [],
}: IntermediaryDetailsDocumentsModuleProps) {
  const { t } = useTranslation();
  const { brokerageFirmId } = useAssertedParams();

  const { data: generatedDocumentCategories = [] } = useQuery({
    ...configControllerGetPublicTenantConfigQueryOptions(),
    select: tenantConfig => {
      const contractType = tenantConfig.distributionRequest?.contractConfig?.signature?.type;
      return contractType ? [{ category: contractType }] : [];
    },
  });

  const { data: uploadedDocumentsList = [] } = useExpectedUploadedDocuments({ brokerageFirmId });

  return (
    <>
      {generatedDocumentCategories.length > 0 && (
        <DocumentsListBrokerageFirmModule
          documentsList={generatedDocumentCategories}
          title={t('intermediaryDetailsDocuments.generatedDocumentsTitle')}
        />
      )}

      <DocumentsUploadBrokerageFirmModule
        documentsLists={[...uploadedDocumentsList, ...extraDocuments]}
        title={t('intermediaryDetailsDocuments.uploadedDocumentsTitle')}
        showFraud
      />
    </>
  );
}
